import axios from "axios";
export function getEventStudentMessageAction() {
  return axios.get(
    process.env.VUE_APP_API_URL + "EventStudentMessageAction/getlist"
  );
}

export function postEventStudentMessageAction(data) {
  return axios.post(
    process.env.VUE_APP_API_URL + "EventStudentMessageAction/add",
    data
  );
}

export function updateEventStudentMessageAction(data) {
  return axios.put(
    process.env.VUE_APP_API_URL + "EventStudentMessageAction/update",
    data
  );
}

export function deleteEventStudentMessageAction(eventStudentMessageActionId) {
  const config = {
    params: {
      eventStudentMessageActionId: eventStudentMessageActionId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "EventStudentMessageAction/deleted",
    config
  );
}
